import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { UncontrolledColourPicker } from './uncontrolled';
import { FormErrorMessage } from '../form/error-message';
export function FormColourPicker({ name, options }) {
    const { field, fieldState } = useController({ name });
    return (_jsxs("div", { children: [_jsx(UncontrolledColourPicker, { color: field.value, onChange: (color) => {
                    field.onChange(color);
                }, options: options }), _jsx(FormErrorMessage, { error: fieldState.error?.message })] }));
}
// Re-export from uncontrolled
export { UncontrolledColourPicker };
